import { ColumnConfigKey } from "../types/page-config/column-customizer/ColumnConfigKey";
import { bwicColumnsLabels } from "./bwicColumnsLabels";

export const inventoryColumnLabels: { [key in ColumnConfigKey]: string } = {
    ...bwicColumnsLabels,
    [ColumnConfigKey.Size]: 'Offer Size, MM',
    [ColumnConfigKey.OfferDmBps]: 'Offer DM, bps',
}